var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.hasHeader?'header':'noheader',attrs:{"id":"app"}},[(_vm.hasHeader)?_c('headers'):_vm._e(),_c('router-view'),(_vm.hasTab)?_c('tabbar'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }